import { SharedLinkGuard } from '@/entities/shared-link/ui';

import ReportDetailPage from './ReportDetailPage';

const PublicReportPage = () => {
  return (
    <SharedLinkGuard>
      <ReportDetailPage />
    </SharedLinkGuard>
  );
};

export default PublicReportPage;
